<ng-container [formGroup]="form">
  <textarea class="form-control" [rows]="element.rows || null"  [autocomplete]="element.autocomplete || null" [formControlName]="element.form" [ngClass]="{'is-invalid': isInvalid}" [placeholder]="element.placeholder || ''" ></textarea>
  <div class="invalid-feedback" *ngIf="isInvalid">
    <span *ngIf="isRequired">Please provide a valid {{ element.label }}</span>
  </div>
</ng-container>
